export default __webpack_public_path__ + "static/media/close_black.ee91b6a4.svg";